import React, { useState, useEffect } from "react";
import { Table, Typography, Spin } from "antd";
import PropTypes from "prop-types";
import { getCreatorMangoEarnings } from "../api";

const MangoExpandTable = ({ creatorId, startDate, endDate }) => {
  const [mangos, setMangos] = useState([]);
  const [loading, setLoading] = useState(false);

  const columnData = [
    {
      title: "Mango Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Earnings",
      dataIndex: "earning",
      key: "earning",
    },
    {
      title: "GST",
      dataIndex: "gst",
      key: "gst",
      render: (text, record) => (
        <Typography>{record?.gst?.toFixed(2)}</Typography>
      ),
    },
    {
      title: "Number of Orders",
      dataIndex: "nOrders",
      key: "nOrders",
    },
  ];

  useEffect(() => {
    const fetchMangoEarnings = async () => {
      if (!creatorId) return;

      setLoading(true);
      try {
        const response = await getCreatorMangoEarnings(
          creatorId,
          startDate,
          endDate
        );

        if (response?.code === 0) {
          setMangos(response.result || []);
        } else {
          console.error("Failed to fetch mango earnings:", response?.message);
          setMangos([]);
        }
      } catch (error) {
        console.error("Error fetching mango earnings:", error);
        setMangos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMangoEarnings();
  }, [creatorId, startDate, endDate]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return <Table columns={columnData} dataSource={mangos} pagination={false} />;
};

MangoExpandTable.propTypes = {
  creatorId: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};

export default MangoExpandTable;
